// extracted by mini-css-extract-plugin
export default {"mainCaption":"caption__mainCaption___XugTf","subCaption":"caption__subCaption___upvcr"};